module.exports = __webpack_public_path__ + "img/Workflows.7011392b.svg";